var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageContainer',[_c('AmeliproErrorTemplate',{attrs:{"error-type":"error404","btn-href":"/login"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }